import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { classifyReadFailure } from "@/api/read-policy";
export function ReadFailureNotice({
  error,
  resource,
  onRetry,
  isRetrying,
  isCoolingDown = false,
  retained,
}: {
  error: unknown;
  resource: string;
  onRetry: () => void;
  isRetrying: boolean;
  isCoolingDown?: boolean;
  retained?: string;
}) {
  const kind = isCoolingDown ? "rate-limited" : classifyReadFailure(error);
  const message =
    kind === "unauthenticated"
      ? `Your session could not be confirmed for ${resource}. Sign in again if needed.`
      : kind === "forbidden"
        ? `You do not have permission to view ${resource}.`
        : kind === "missing"
          ? `The requested ${resource} could not be found.`
          : kind === "rate-limited"
            ? `Too many requests for ${resource}. Please wait before retrying.`
            : `Could not load ${resource}. Please retry.`;
  return (
    <Alert variant="destructive">
      <AlertDescription>
        <span>
          {message}
          {retained ? ` ${retained}` : ""}
        </span>
        <Button
          type="button"
          variant="outline"
          className="ml-2"
          disabled={isRetrying || isCoolingDown}
          onClick={onRetry}
        >
          {isCoolingDown ? "Please wait" : isRetrying ? "Retrying…" : "Retry"}
        </Button>
      </AlertDescription>
    </Alert>
  );
}
